import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Modal, Button } from '@bingads-webui-react/primitive';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@bingads-webui-react/fabric-control';

import { useStyles } from '../styles/consolidated-billing';

const name = 'delete-accounts';

const columns = [
  {
    key: 'name',
    name: 'Name',
    fieldName: 'Name',
    minWidth: 100,
    isResizable: true,
  },
  {
    key: 'number',
    name: 'Number',
    fieldName: 'Number',
    minWidth: 100,
    maxWidth: 100,
    isResizable: true,
  },
];

export const DeleteAccountsDialog = ({
  onConfirm,
  onDecline,
  accountList,
  confirmButtonDisabled,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();

  return (
    <Modal
      show
      backdrop="static"
      backdropClassName={classes.customBackdrop}
      dialogClassName={classes.customSizeModal}
      className={classnames(`${name}-confirm-dialog`, classes.deleteAccountsConfirmDialog)}
      bsSize="lg"
      onHide={onDecline}
    >
      <Modal.Header closeButton>
        <Modal.Title>{i18n.getString(_TL_('Remove account(s) from the billing group'))}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`${name}-confirm-dialog-content`}>
        <p>
          {i18n.getString(_TL_('The spend before removing account(s) from this billing group will still be consolidated according to the billing group settings.'))}
        </p>
        <p>
          {i18n.getString(_TL_('After you remove the account(s) from the billing group, the new spend will follow the new billing group settings.'))}
        </p>
        <div><strong>{i18n.getString(_TL_('Accounts to be removed'))}</strong></div>
        <div className={classes.accountList}>
          <DetailsList
            isHeaderVisible={false}
            items={accountList}
            columns={columns}
            layoutMode={DetailsListLayoutMode.justified}
            selectionMode={SelectionMode.none}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="confirm-button" btnStyle="primary" onClick={onConfirm} disabled={confirmButtonDisabled}>{i18n.getString(_TL_('Confirm and remove'))}</Button>
        <Button className="decline-button" onClick={onDecline}>{i18n.getString(_TL_('Cancel'))}</Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteAccountsDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  confirmButtonDisabled: PropTypes.bool,
};
DeleteAccountsDialog.defaultProps = {
  confirmButtonDisabled: false,
};
